// FE-M2 · persona palette extension (5 → 13 personas).
// Per docs/frontend_eng_spec/m0_5/persona_palette.md §1 + §2 (a7 audit fixed).
//
// 2 new physical Tailwind tokens (rose-pearl, ash) + 5 reused 云隐 tokens via
// modifier ramps (deep / light / muted). Safe-fallback to paper-pearl on
// unknown id (R4 invariant: persona resilience — render must not crash).
import type { PersonaId } from '@/store/session';

export interface PersonaPalette {
  id: PersonaId;
  /** Tailwind color token (e.g. 'xuan', 'rose-pearl'). */
  accent: string;
  modifier: 'default' | 'deep' | 'light' | 'muted' | 'warm-grey';
  tone: 'cool' | 'warm' | 'neutral' | 'severe';
}

export const PERSONA_PALETTE: Record<PersonaId, PersonaPalette> = {
  sage:           { id: 'sage',           accent: 'xuan',       modifier: 'default',   tone: 'severe' },
  sage_synthesis: { id: 'sage_synthesis', accent: 'xuan',       modifier: 'default',   tone: 'severe' },
  iron:           { id: 'iron',           accent: 'vermilion',  modifier: 'default',   tone: 'severe' },
  hammer:         { id: 'hammer',         accent: 'gold',       modifier: 'default',   tone: 'warm' },
  compass:        { id: 'compass',        accent: 'jade',       modifier: 'default',   tone: 'cool' },
  horizon:        { id: 'horizon',        accent: 'azure',      modifier: 'default',   tone: 'cool' },
  architect:      { id: 'architect',      accent: 'xuan',       modifier: 'deep',      tone: 'cool' },
  scribe:         { id: 'scribe',         accent: 'gold',       modifier: 'light',     tone: 'warm' },
  steward:        { id: 'steward',        accent: 'vermilion',  modifier: 'muted',     tone: 'severe' },
  mediator:       { id: 'mediator',       accent: 'jade',       modifier: 'muted',     tone: 'neutral' },
  mirror:         { id: 'mirror',         accent: 'azure',      modifier: 'light',     tone: 'cool' },
  empath:         { id: 'empath',         accent: 'rose-pearl', modifier: 'default',   tone: 'warm' },
  ideator:        { id: 'ideator',        accent: 'ash',        modifier: 'warm-grey', tone: 'neutral' },
};

const FALLBACK: PersonaPalette = {
  id: 'sage',
  accent: 'paper-pearl',
  modifier: 'default',
  tone: 'neutral',
};

/** Safe-fallback lookup. Unknown id → muted paper-pearl (no crash). */
export function getPersonaPalette(id: string): PersonaPalette {
  return (PERSONA_PALETTE as Record<string, PersonaPalette>)[id] ?? FALLBACK;
}
